import EnterAddressField from "./EnterAddressField";
import {FocusEventHandler, MutableRefObject, useEffect, useState} from "react";
import axios, {AxiosResponse} from "axios";
import {ISuggestResult, ISuggestResults} from "./EnterAddressView";
import {searchAddresses} from "./Geocoding";

interface IAddressSearchProps {
    onSelectOnMap: () => void
    showSelectOnMapButton: boolean
    onAddressesUpdate: (r: Array<ISuggestResult>) => void,
    onFocus: FocusEventHandler<HTMLElement>,
    onBlur: FocusEventHandler<HTMLElement>
    value: string,
}

export default function AddressSearch(props: IAddressSearchProps) {
    const [value, setValue] = useState<string>(props.value);

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    useEffect(() => {
        if (value.length === 0) {
            props.onAddressesUpdate([]);
            return;
        }

        searchAddresses(
            value,
            (a) => props.onAddressesUpdate(a),
            source
        );
        return () => source.cancel();
    }, [value]);

    return <EnterAddressField
        value={value}
        onClear={() => setValue("")}
        onSelectOnMap={props.onSelectOnMap} showSelectOnMapButton={props.showSelectOnMapButton}
        onFocus={props.onFocus} onBlur={props.onBlur} onChange={(text) => setValue(text)}/>
}